export default function CaseStudy() {
  return (
    <section className="py-20 sm:py-24 lg:py-28 px-4 sm:px-6 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16 sm:mb-20">
          <div className="inline-block mb-5 sm:mb-7">
            <span className="border-2 border-[#1e3a8a] text-[#1e3a8a] text-xs font-semibold px-4 sm:px-6 py-2 rounded-full uppercase tracking-wider whitespace-nowrap">
              Case Study
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1e3a8a] mb-5 sm:mb-7 leading-tight px-4">
            これまでの取り組み例
          </h2>
        </div>

        {/* ケーススタディ詳細 */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="bg-gradient-to-r from-[#1e3a8a] to-[#3b82f6] p-6 sm:p-8 text-white">
            <h3 className="text-2xl sm:text-3xl font-bold text-center">韓国聖地巡礼ツアー</h3>
          </div>

          <div className="p-8 sm:p-10 lg:p-12 space-y-10 sm:space-y-12">
            {/* 背景・課題 */}
            <div className="flex gap-4 sm:gap-6">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-[#1e3a8a] to-[#3b82f6] rounded-full flex items-center justify-center">
                  <i className="ri-question-line text-xl sm:text-2xl text-white"></i>
                </div>
              </div>
              <div className="flex-1 lg:max-w-3xl">
                <h4 className="text-lg sm:text-xl lg:text-2xl font-bold text-[#1e3a8a] mb-3 sm:mb-4">背景・課題</h4>
                <p className="text-sm sm:text-base lg:text-[20px] text-gray-700 leading-relaxed lg:leading-[1.8]">
                  従来型の「価格・写真」中心の広報では、50代以上の女性層が求める「旅の背景」や「参加する意味」が伝わりきらない課題がありました。
                </p>
              </div>
            </div>

            {/* 施策 */}
            <div className="flex gap-4 sm:gap-6">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-[#1e3a8a] to-[#3b82f6] rounded-full flex items-center justify-center">
                  <i className="ri-lightbulb-line text-xl sm:text-2xl text-white"></i>
                </div>
              </div>
              <div className="flex-1 lg:max-w-3xl">
                <h4 className="text-lg sm:text-xl lg:text-2xl font-bold text-[#1e3a8a] mb-3 sm:mb-4">施策(アプローチ)</h4>
                <p className="text-sm sm:text-base lg:text-[20px] text-gray-700 leading-relaxed lg:leading-[1.8]">
                  独自のコミュニティを軸に、観光案内ではなく「体験の文脈」を丁寧に共有。SNSは、コミュニティ内の熱量を可視化し、検討者の背中を後押しする<strong className="text-[#1e3a8a]">「信頼の証」</strong>として戦略的に運用しました。
                </p>
              </div>
            </div>

            {/* 証拠画像 */}
            <div className="flex justify-center">
              <div className="w-full max-w-4xl">
                <img 
                  src="https://static.readdy.ai/image/5b3c9bf2cc89003aa9f6224022a3d624/04df1ca6200be2aa585bbf0eacf72aba.jpeg" 
                  alt="韓国聖地巡礼ツアーの参加者集合写真"
                  className="w-full h-auto rounded-xl shadow-lg object-cover"
                />
                <p className="text-sm sm:text-base lg:text-lg text-gray-600 text-center mt-4 leading-relaxed px-4">
                  実際のツアーの様子
                </p>
              </div>
            </div>

            {/* 結果 */}
            <div className="flex gap-4 sm:gap-6">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-[#d4af37] to-[#f4d03f] rounded-full flex items-center justify-center">
                  <i className="ri-trophy-line text-xl sm:text-2xl text-white"></i>
                </div>
              </div>
              <div className="flex-1 lg:max-w-3xl">
                <h4 className="text-lg sm:text-xl lg:text-2xl font-bold text-[#1e3a8a] mb-3 sm:mb-4">結果(ベネフィット)</h4>
                <p className="text-sm sm:text-base lg:text-[20px] text-gray-700 leading-relaxed lg:leading-[1.8]">
                  同年代との交流による高い安心感と満足度を獲得し、一過性に終わらない<strong className="text-[#1e3a8a]">「継続的なツアーモデル」</strong>を確立しました。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}